module.exports = __webpack_public_path__ + "img/Dosoftei_Psaltirea_in_versuri_Uniev_1673_foaie_de_titlu.75bfa831.jpg";